/* block */
if (typeof gtag !== 'undefined') {
    gtag('event', 'conversion', {'send_to':'AW-16586792740/ouCwCOyE_occEKS-meU9','value':500.0,'currency':'NZD'});
  }

/* block */
if (typeof fbq !== 'undefined') {
    fbq('track', 'Lead', {value: 500.0, currency: 'NZD', content_name: 'Upholstery Repair Quote'});
  }

/* block */
if (typeof gtag !== 'undefined') {
    gtag('event', 'repair_quote_submit', {'page_location': window.location.href, 'value': 500.0, 'currency': 'NZD'});
  }
